module.exports = __webpack_public_path__ + "img/yt.acd69b98.svg";